<template>

<app-content :loading="is.loading">

	<app-content-head title="Slot Wizard" back="Convention.Volunteers.Slots" :readonly="$authorised('con/volunteers/access', 'read')">

		<app-content-head-actions-item :loading="is.saving" :disabled="!isValid" icon="generate" text="Create" v-on:click="onSaveClick" />
		
	</app-content-head>

	<app-content-body v-if="is.initialised">

        <app-content-box>
 
            <app-input-checklist label="Applicable Days" :columns="3" :asString="true" v-model="model.days" :validation="$v.model.days" :options="references.days" :multiple="true" :column="true" />
                    
            <app-input-text label="Slots per Day" placeholder="Enter number..." v-model="model.daily" :validation="$v.model.daily" :numeric="true" />
                    
            <app-input-select label="Start Time" v-model="model.start" :validation="$v.model.start" :options="references.times" placeholder="Select time" />
                    
            <app-input-select label="Slot Duration" v-model="model.duration" :validation="$v.model.duration" :options="references.durations" placeholder="Select duration" />
                    
            <app-input-select label="Slot Overlap" v-model="model.overlap" :validation="$v.model.overlap" :options="references.durations" :allow-zero="true" placeholder="Select overlap" notes="Have slots overlap to facilitate handover of responsibilities between volunteers. Otherwise they are scheduled end-to-end." />
                    
            <app-input-text label="Volunteers per Slot" placeholder="Enter number..." v-model="model.capacity" :validation="$v.model.capacity" :numeric="true" />

        </app-content-box>

	</app-content-body>

</app-content>

</template>

<script>

import mixForm from '@/mixin/form'
import { required, minValue, minLength } from 'vuelidate/lib/validators'

export default {

	mixins: [mixForm],

	data: function() {

		return {
            standalone: true,
			readonly: this.$authorised('con/volunteers/access', 'read'),
			references: {
				days: [],
				durations: [],
				times: []
			},
			model: {
                days: [],
                start: 0,
                daily: 1,
                duration: 0,
                overlap: 0,
                capacity: 1
            },
			api: 'convention/volunteers/roles/:role/slots/wizard',
		}

	},

	validations: {
		model: {
			days: {
				required,
                minLength: minLength(1)
			},
			duration: {
				required,
                minValue: minValue(1)
			},
			daily: {
				required,
                minValue: minValue(1)
			},
			start: {
				required,
                minValue: minValue(1)
			},
			capacity: {
				required,
                minValue: minValue(1)
			}
		}
	},

    computed: {
    
        savedMessage: function() {
        
            return 'You have successfully generated the slots.'
        
        }
    
    },

    methods: {
    
        onSaved: function() {
        
            this.$router.push({
                name: 'Convention.Volunteers.Slots'
            })
        
        }
    
    }

}

</script>

<style scoped>

</style>